import moment from 'moment';

export function RsPayoutTransfersService($http, apexApiUrl) {
    'ngInject';
    return {
        createRSPayoutTransfer: createRSPayoutTransfer,
        retrieveRSPayoutTransfers: retrieveRSPayoutTransfers,
        updateRSPayoutTransfer: updateRSPayoutTransfer,
        deleteRSPayoutTransfer: deleteRSPayoutTransfer
    };


    function retrieveRSPayoutTransfers(startDate, endDate, icdCorporation) {
        const params = {};
        if (startDate) {
            params.startDate = moment(startDate).format("YYYY-MM-DD");
        }
        if (endDate) {
            params.endDate = moment(endDate).format("YYYY-MM-DD");
        }
        params.icdCorporation = icdCorporation;
        return $http({
            method: "GET",
            params: params,
            url: apexApiUrl + "rs-payout-transfers",
            headers: { Accept: "application/json" }
        }).then(function (response) {
            return response.data;
        });
    }

    function createRSPayoutTransfer(data) {

        return $http({
            method: "POST",
            data: data,
            url: apexApiUrl + "rs-payout-transfers",
            headers: { Accept: "application/json" }
        }).then(function (response) {
            return response.data;
        });
    }

    function updateRSPayoutTransfer(id, transfer) {

        return $http({
            method: "PUT",
            url: apexApiUrl + "rs-payout-transfers/" + id,
            data: transfer

        });
    }

    function deleteRSPayoutTransfer(id) {
        return $http({
            method: "DELETE",
            url: apexApiUrl + "rs-payout-transfers/" + id
        });
    }
}
